import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';

const GoogleSSOLogin = ({ setAuthenticated }) => {
  const navigate = useNavigate();

  return (
    <GoogleOAuthProvider clientId="824229440529-bfpasrlsldm5khqf7vu1ai4p8a65lreq.apps.googleusercontent.com">
      <div className="google-sso-container">
        <GoogleLogin
          onSuccess={async (credentialResponse) => {
            try {
              // Send to backend for verification

              const response = await fetch(`${process.env.REACT_APP_FUTSAL_DIRECTORY_API_URL}/api/admin/auth/google`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token: credentialResponse.credential }),
              });

              console.log(`${process.env.REACT_APP_FUTSAL_DIRECTORY_API_URL}/api/admin/auth/google`)
              console.log(process.env.REACT_APP_FUTSAL_DIRECTORY_API_URL)

              if (response.ok) {
                const data = await response.json();
                console.log(data)
                setAuthenticated(true);
                navigate('/admin/dashboard');
              } else {
                throw new Error('Authentication failed');
              }
            } catch (error) {
              console.error('Login failed:', error);
              alert('Login failed. Please try again or contact support.');
            }
          }}
          onError={() => {
            console.log('Login Failed');
            alert('Google login failed. Please try again.');
          }}
          useOneTap
          auto_select
        />
      </div>
    </GoogleOAuthProvider>
  );
};

export default GoogleSSOLogin;